module.exports = __webpack_public_path__ + "static/media/surfboardsHome2.e70efe05.jpg";